// extracted by mini-css-extract-plugin
module.exports = {"container":"Gdumo","triangle":"_11EMY","right":"hSR-i","left":"_3VKyu"};